<template>
  <div class="container login-wrap">
    <router-view name="sidebar"></router-view>
    <Login />
    <button type="button" class="support" @click="openQuestions">
      {{ $t('no_booking_yet_contact_our_support') }}
    </button>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Login from '@/components/Login';

@Component({
  name: 'login-page',
  components: {
    Login,
  },
})
class LoginPage extends Vue {
  @Action openQuestions;

  @Action loginByMagicLink;

  @Action hideBookingLoader;

  mounted() {
    this.hideBookingLoader();
  }
}

export default LoginPage;
</script>
<style scoped lang="scss">
.login-wrap {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -100px;
  @include mobile {
    margin-top: 0;
  }
}
.support {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: $dark-grey;
  transition: 0.15s ease-in-out;
  border: none;
  background: none;
  &:hover {
    color: #000;
  }
}
</style>
